import {
  ZoneOffset as ZoneOffset,
  ChronoField as ChronoField,
  DateTimeFormatterBuilder as DateTimeFormatterBuilder,
  ResolverStyle as ResolverStyle,
} from '@js-joda/core';
import { FixedOffsetTimeZone3oldrgkltiv4z as FixedOffsetTimeZone } from './TimeZone.mjs';
import { KProperty02ce7r476m8633 as KProperty0 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  get_ISO_OFFSET1wt81dckmqhlf as get_ISO_OFFSET,
  get_ISO_OFFSET_BASICumnsw87b3jry as get_ISO_OFFSET_BASIC,
  get_FOUR_DIGIT_OFFSET2nvpbkfa3o459 as get_FOUR_DIGIT_OFFSET,
} from './format/UtcOffsetFormat.mjs';
import { UtcOffsetSerializer_getInstancehfvjgq5w8o12 as UtcOffsetSerializer_getInstance } from './serializers/TimeZoneSerializers.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  isJodaDateTimeException2l3lhdyy3jadv as isJodaDateTimeException,
  isJodaDateTimeParseException1w7urgwwcr7j6 as isJodaDateTimeParseException,
} from './JSJodaExceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { DateTimeFormatException2onfeknbywaob as DateTimeFormatException } from './Exceptions.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function asTimeZone(_this__u8e3s4) {
  return FixedOffsetTimeZone().d1p(_this__u8e3s4);
}
function getIsoUtcOffsetFormat() {
  return Formats_instance.n1o();
}
function get_isoFormat() {
  _init_properties_UtcOffset_kt__93zod7();
  var tmp0 = isoFormat$delegate;
  var tmp = KProperty0();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('isoFormat', 0, tmp, _get_isoFormat_$ref_2mb9ng(), null);
  return tmp0.f2();
}
var isoFormat$delegate;
function get_isoBasicFormat() {
  _init_properties_UtcOffset_kt__93zod7();
  var tmp0 = isoBasicFormat$delegate;
  var tmp = KProperty0();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('isoBasicFormat', 0, tmp, _get_isoBasicFormat_$ref_gohyt6(), null);
  return tmp0.f2();
}
var isoBasicFormat$delegate;
function get_fourDigitsFormat() {
  _init_properties_UtcOffset_kt__93zod7();
  var tmp0 = fourDigitsFormat$delegate;
  var tmp = KProperty0();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('fourDigitsFormat', 0, tmp, _get_fourDigitsFormat_$ref_k5ys7r(), null);
  return tmp0.f2();
}
var fourDigitsFormat$delegate;
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.i26_1 = new (UtcOffset())(ZoneOffset.UTC);
      }
      q27(input, format) {
        return format === Formats_instance.n1o() ? parseWithFormat(input, get_isoFormat()) : format === Formats_instance.r27() ? parseWithFormat(input, get_isoBasicFormat()) : format === Formats_instance.k1r() ? parseWithFormat(input, get_fourDigitsFormat()) : format.ev(input);
      }
      j26(input, format, $super) {
        format = format === VOID ? getIsoUtcOffsetFormat() : format;
        return $super === VOID ? this.q27(input, format) : $super.q27.call(this, input, format);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var FormatsClass;
function Formats() {
  if (FormatsClass === VOID) {
    class $ {
      n1o() {
        return get_ISO_OFFSET();
      }
      r27() {
        return get_ISO_OFFSET_BASIC();
      }
      k1r() {
        return get_FOUR_DIGIT_OFFSET();
      }
    }
    initMetadataForObject($, 'Formats');
    FormatsClass = $;
  }
  return FormatsClass;
}
var Formats_instance;
function Formats_getInstance() {
  return Formats_instance;
}
var UtcOffsetClass;
function UtcOffset() {
  if (UtcOffsetClass === VOID) {
    class $ {
      constructor(zoneOffset) {
        Companion_getInstance();
        this.j1s_1 = zoneOffset;
      }
      k1s() {
        return this.j1s_1.totalSeconds();
      }
      hashCode() {
        return this.j1s_1.hashCode();
      }
      equals(other) {
        var tmp;
        if (other instanceof UtcOffset()) {
          tmp = this.j1s_1 === other.j1s_1 || this.j1s_1.equals(other.j1s_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      toString() {
        return this.j1s_1.toString();
      }
    }
    initMetadataForClass($, 'UtcOffset', VOID, VOID, VOID, VOID, VOID, {0: UtcOffsetSerializer_getInstance});
    UtcOffsetClass = $;
  }
  return UtcOffsetClass;
}
function UtcOffset_0(hours, minutes, seconds) {
  hours = hours === VOID ? null : hours;
  minutes = minutes === VOID ? null : minutes;
  seconds = seconds === VOID ? null : seconds;
  _init_properties_UtcOffset_kt__93zod7();
  var tmp;
  try {
    var tmp_0;
    if (!(hours == null)) {
      // Inline function 'kotlinx.datetime.jsTry' call
      var tmp_1 = ZoneOffset;
      var tmp_2 = minutes == null ? 0 : minutes;
      var tmp$ret$1 = tmp_1.ofHoursMinutesSeconds(hours, tmp_2, seconds == null ? 0 : seconds);
      tmp_0 = new (UtcOffset())(tmp$ret$1);
    } else if (!(minutes == null)) {
      // Inline function 'kotlinx.datetime.jsTry' call
      var tmp_3 = ZoneOffset;
      var tmp_4 = minutes / 60 | 0;
      var tmp_5 = minutes % 60 | 0;
      var tmp$ret$3 = tmp_3.ofHoursMinutesSeconds(tmp_4, tmp_5, seconds == null ? 0 : seconds);
      tmp_0 = new (UtcOffset())(tmp$ret$3);
    } else {
      // Inline function 'kotlinx.datetime.jsTry' call
      var tmp_6 = ZoneOffset;
      var tmp$ret$5 = tmp_6.ofTotalSeconds(seconds == null ? 0 : seconds);
      tmp_0 = new (UtcOffset())(tmp$ret$5);
    }
    tmp = tmp_0;
  } catch ($p) {
    var tmp_7;
    if ($p instanceof Error) {
      var e = $p;
      var tmp_8;
      if (isJodaDateTimeException(e)) {
        throw IllegalArgumentException().be(e);
      } else {
        throw e;
      }
    } else {
      throw $p;
    }
  }
  return tmp;
}
function parseWithFormat(input, format) {
  _init_properties_UtcOffset_kt__93zod7();
  var tmp;
  try {
    // Inline function 'kotlinx.datetime.jsTry' call
    tmp = format.parse(toString(input)).get(ChronoField.OFFSET_SECONDS);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var e = $p;
      if (isJodaDateTimeParseException(e))
        throw DateTimeFormatException().y1n(e);
      if (isJodaDateTimeException(e))
        throw DateTimeFormatException().y1n(e);
      throw e;
    } else {
      throw $p;
    }
  }
  return UtcOffset_0(VOID, VOID, tmp);
}
function isoFormat$delegate$lambda() {
  _init_properties_UtcOffset_kt__93zod7();
  return (new DateTimeFormatterBuilder()).parseCaseInsensitive().appendOffsetId().toFormatter(ResolverStyle.STRICT);
}
function _get_isoFormat_$ref_2mb9ng() {
  return () => get_isoFormat();
}
function isoBasicFormat$delegate$lambda() {
  _init_properties_UtcOffset_kt__93zod7();
  return (new DateTimeFormatterBuilder()).parseCaseInsensitive().appendOffset('+HHmmss', 'Z').toFormatter(ResolverStyle.STRICT);
}
function _get_isoBasicFormat_$ref_gohyt6() {
  return () => get_isoBasicFormat();
}
function fourDigitsFormat$delegate$lambda() {
  _init_properties_UtcOffset_kt__93zod7();
  return (new DateTimeFormatterBuilder()).parseCaseInsensitive().appendOffset('+HHMM', '+0000').toFormatter(ResolverStyle.STRICT);
}
function _get_fourDigitsFormat_$ref_k5ys7r() {
  return () => get_fourDigitsFormat();
}
var properties_initialized_UtcOffset_kt_4gxffr;
function _init_properties_UtcOffset_kt__93zod7() {
  if (!properties_initialized_UtcOffset_kt_4gxffr) {
    properties_initialized_UtcOffset_kt_4gxffr = true;
    isoFormat$delegate = lazy(isoFormat$delegate$lambda);
    isoBasicFormat$delegate = lazy(isoBasicFormat$delegate$lambda);
    fourDigitsFormat$delegate = lazy(fourDigitsFormat$delegate$lambda);
  }
}
//region block: init
Formats_instance = new (Formats())();
//endregion
//region block: exports
export {
  Companion_getInstance as Companion_getInstance3p275ab8rhrps,
  Formats_instance as Formats_instance4hly74zje37n,
  UtcOffset_0 as UtcOffset2q1jzx5thduw7,
  UtcOffset as UtcOffset17lxgyhnn4rny,
  asTimeZone as asTimeZone3kdzfpoilmjbj,
};
//endregion

//# sourceMappingURL=UtcOffset.mjs.map
